import { Flexbox } from "st-app";
import { GroupAction } from "./GroupAction";
import { Group } from "./Group";

import styles from '../sis-role-dashboard.module.css'
import { UserSuggestions } from "./UserSuggestions";
import { EnrollmentActivity } from "./EnrollmentActivity";
import { UserRecentHistory } from "./UserRecentHistory";
import { For, createMemo } from "solid-js";
import { requireRoleDashboardContext } from "../RoleDashboardContext";
import { StaffRole } from "../../../api/SISApp";

export function RegistrarDashboard() {
    const ctx = requireRoleDashboardContext();

    const tasks = ctx.sortedActions([
        'K12.Student.EnrollStudent',
        'K12.Student.ActivateStudent',
        'K12.Student.InactivateStudent',
        'K12.OnlineEnrollment.OLRQueue',
        'K12.Student.NoShow',
        'Registrar.ESRRequest',
        'K12.LoginParent',
        'K12.LocateStudent',
        'K12.ContactStudent',
    ]);

    const shortcuts = createMemo(() => {
        const addShortcuts = ctx.configuration()
            ?.additionalShortcuts
            .filter(desc => desc.role === StaffRole.Registrar)
            .map(desc => desc.ID!);

        return ctx.sortedActions([
            'Revelation.ReportBrowser',
            'Revelation.Analytics',
            'K12.PersonSearch',
            'Registrar.Student',
            'Registrar.WalkInSched',
            'Registrar.StudentCourseHistory',
            'Registrar.StudentCareerPlan',
            'Registrar.StudentNeeds',
        ].concat(addShortcuts ?? []));
    });

    return <Flexbox dir="horizontal" auto class={styles['dashboard-content']} >
        <Flexbox dir="vertical" auto>
            <Group title="Tasks" icon="fas fa-graduation-cap" color="--header-green">
                <For each={tasks}>{id => <GroupAction id={id} />}</For>
            </Group>

            <Group title="Shortcuts" icon="fas fa-info-circle" color="--header-blue">
                <For each={shortcuts()}>{id => <GroupAction id={id} allowDetach />}</For>
            </Group>

            <EnrollmentActivity />

            <UserSuggestions />
            <Flexbox.Item auto />
        </Flexbox>
        <UserRecentHistory />
    </Flexbox>
}

